<template>
  <div class="alarm-rule-container">
    <div class="query-data-area">
      <span class="ml10">{{showLang('com.tab.title')}}：</span>
      <Input type="text" v-model="filter.name" clearable :placeholder="showLang('com.device.pole.name')"
        style="width: 200px; margin-right: 10px;"></Input>
      {{showLang('com.import.cn.pole.type')}}：
      <Select v-model="filter.poleTypeId" style="width: 200px; margin-right: 10px;">
        <Option value="all">{{showLang('com.state.all')}}</Option>
        <Option v-for="(s, idx) in poleTypes" :key="idx" :value="s.id">{{s.name}}</Option>
      </Select>
      {{showLang('com.import.cn.arm.type')}}：
      <Select v-model="filter.armTypeId" style="width: 200px; margin-right: 10px;">
        <Option value="all">{{showLang('com.state.all')}}</Option>
        <Option v-for="(s, idx) in armTypes" :key="idx" :value="s.id">{{s.name}}</Option>
      </Select>
      {{showLang('com.min.height')}}(M)：
      <Input type="number" v-model="filter.min" clearable style="width: 150px; margin-right: 10px;"></Input>
      {{showLang('com.max.height')}}(M)：
      <Input type="number" v-model="filter.max" clearable style="width: 150px; margin-right: 10px;"></Input>
      <Button size="default" type="primary" @click="getList"
        style="margin-right: 10px;">{{showLang('com.op.query')}}</Button>
    </div>
    <div class="query-data-area">
      <Button v-if="funCodes('lpd2')" size="default" type="error" @click="deleteParams" style="margin: 0 5px;">{{showLang('com.op.batch.del')}}</Button>
      <!-- <Button size="default" type="success" @click="handleExport" style="margin: 0 5px;">{{showLang('export.pole.info.barcode')}}</Button> -->
      <Button size="default" type="success" @click="handleExport1" style="margin: 0 5px;">{{showLang('export.pole.info')}}</Button>
      <Button v-if="funCodes('lpa2')" size="default" type="info" @click="getImportTemplate" style="margin: 0 5px;">{{showLang('import.template.file')}}</Button>
      <Button v-if="funCodes('lpa2')" size="default" type="success" @click="handleImport" style="margin: 0 5px;">{{showLang('import.pole.info')}}</Button>
      <Button v-if="funCodes('lpa2')" type="primary" size="default" style="margin: 0 5px" @click="fastAdd">{{showLang('com.op.entry')}}</Button>
      <Button v-if="funCodes('lpe2')" type="primary" style="margin-right: 5px" @click="handleBatchSetHeight">{{showLang('batch.modify.height')}}</Button>
    </div>
    <div class="alarm-data-area" ref="table1">
      <vxe-table :empty-text="showLang('com.data.no')" border resizable show-overflow show-header-overflow keep-source
        ref="chkTable" @checkbox-change="selectChangeEvent" :data="list" :height="tabHeight"
        :row-config="{isHover: true}" :checkbox-config="{checkField: 'checked',}" @checkbox-all="selectAllEvent"
        :seq-config="{startIndex: (filter.index-1)*filter.size}" row-id="id" :key="dataRefresh">
        <vxe-column type="seq" width="60" :title="showLang('com.export.cn.seq')" fixed="left"></vxe-column>
        <vxe-column width="50" type="checkbox" field="checkbox" fixed="left"></vxe-column>
        <vxe-column field="name" :title="showLang('com.tab.title')" header-align="center" fixed="left">
          <template #default="{ row }">
            {{row.name}}
          </template>
        </vxe-column>
        <vxe-column field="groupName" :title="showLang('op.com.Partition')" sortable width="200"
          header-align="center">
          <template #default="{ row }">
            {{row.groupName}}
          </template>
        </vxe-column>
        <vxe-column field="poleTypeName" :title="showLang('com.import.cn.pole.type')" sortable width="120"
          header-align="center">
          <template #default="{ row }">
            {{row.poleTypeName}}
          </template>
        </vxe-column>
        <vxe-column field="armTypeName" :title="showLang('com.import.cn.arm.type')" sortable width="120"
          header-align="center">
          <template #default="{ row }">
            {{row.armTypeName}}
          </template>
        </vxe-column>
        <vxe-column field="height" :title="showLang('com.import.cn.pole.height')" sortable width="100"
          header-align="center">
          <template #default="{ row }">
            {{row.height}}
          </template>
        </vxe-column>
        <vxe-column field="lng" :title="showLang('com.import.cn.pole.lng')" sortable width="180" header-align="center">
          <template #default="{ row }">
            {{row.lng}}
          </template>
        </vxe-column>
        <vxe-column field="lat" :title="showLang('com.import.cn.pole.lat')" sortable width="180" header-align="center">
          <template #default="{ row }">
            {{row.lat}}
          </template>
        </vxe-column>
        <vxe-column width="180" fixed="right">
          <template slot="header">
            <Button v-if="funCodes('lpa2')" opCode='lpa2' style="margin-right: 5px" @click="handleAdd">{{showLang('com.op.add')}}</Button>
            <Button style="margin-right: 5px" @click="getList">{{showLang('com.op.refresh')}}</Button>
          </template>
          <template #default="{ row }">
            <Button v-if="funCodes('lpe2')" type="primary" size="small" style="margin-right: 5px" @click="handleEdit(row)">{{showLang('com.op.edit')}}</Button>
            <Button v-if="funCodes('lpe2')" type="primary" size="small" style="margin-right: 5px" @click="setPicture(row)">{{showLang('com.op.picture')}}</Button>
            <Button v-if="funCodes('lpd2')" type="error" size="small" @click="handleDelete(row)">{{showLang('com.op.del')}}</Button>
          </template>
        </vxe-column>
      </vxe-table>
      <p>
        <vxe-pager :layouts="pageLayouts" :current-page.sync="filter.index" :page-size.sync="filter.size" :total="total" :page-sizes='pageSizes' @page-change="handlePageChange"></vxe-pager>
      </p>
      <ModalPoleEdit v-model="showEditModal" :item="editItem" :armTypes="armTypes" :poleTypes="poleTypes" @saved="itemSaved" />
      <ModalBatchAdd v-model="showBatchModal" :item="editItem" :armTypes="armTypes" :poleTypes="poleTypes" @saved="itemSaved" />
      <ModalImport v-model="showImportModal" :item="editItem" @saved="itemSaved" />
      <ModalPicture v-model="showPicture" :item="editItem" @saved="itemSaved" />
      <ModalSetArgs v-model="showArgsModal" :item="editItem" @saved="argsSaved" />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ModalPoleEdit from './ModalPoleEdit'
import ModalBatchAdd from './ModalBatchAdd'
import ModalImport from './ModalImport'
import ModalPicture from './ModalPicture'
import ModalSetArgs from './ModalSetArgs'
export default {
  name: 'ConfigLampPoleIndex',
  components: {
    ModalPoleEdit,
    ModalBatchAdd,
    ModalImport,
    ModalPicture,
    ModalSetArgs,
  },
  props: {
  },
  data() {
    return {
      curTab: 'hour24',
      list: [],
      tabHeight: 600,
      editItem: { isAdd: true, data: {} },
      showEditModal: false,
      showArgsModal: false,
      showImportModal: false,
      showBatchModal: false,
      showPicture: false,
      filter: {
        groupId: 0,
        poleId: "",
        name: "",
        armTypeId: "all",
        poleTypeId: "all",
        min: 0,
        max: 100,
        size: 20,
        index: 1,
      },
      total: 0,
      dataRefresh: 0,
      exportExcel: {
        data: [],
        isAll: false,
      },
      armTypes: [],
      poleTypes: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['funCodes', 'showLang']),
    ...mapState('cmd', ['windowOnResize', 'cmds']),
    ...mapState('common', ['weeks', 'pageSizes', 'pageLayouts']),
    ...mapState('group', ['selectedDevices', 'poleSelectedNode']),
  },
  watch: {
    windowOnResize() {
      this.setTableHeight();
    },
    poleSelectedNode() {
      this.filter.index=1;
      this.getList();
    }
  },
  mounted: function () {
    setTimeout(this.setTableHeight, 100);
    this.getArmTypes();
    this.getPoleTypes();
    this.getList();
  },
  destroyed: function () {
  },
  methods: {
    argsSaved: function(params){
      console.log('args saved', params);
      let chks = this.$refs.chkTable.getCheckboxRecords();
      let list = chks.map(p => p.id);
      let title = '', url = '', args = null;
      if(params.type == 'height'){
        title = this.showLang('select.modify.height')
        url = 'pole/config/BatchSetPoleHeight';
        args = { ids: list, height: params.height }
      }else{
        return;
      }
      this.$Modal.confirm({
        title: this.showLang('com.op.prompt'),
        content: title,
        onOk: async () => {
          this.$axios.post(`//${this.domains.trans}/${url}`, args).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    handleBatchSetHeight: function(){
      let chks = this.$refs.chkTable.getCheckboxRecords();
      if (chks.length == 0) {
        this.$Message.warning(this.showLang('ok.modify.height'));
        return;
      }
      this.editItem = {type: 'height'};
      this.showArgsModal = true;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.filter.index = currentPage
      this.filter.size = pageSize
      this.getList(true)
    },
    selectAllEvent({ checked }) {//全选
      this.exportExcel.isAll = checked;
      if (!checked) {
        this.exportExcel.data = [];
      }
    },
    checkRowKeys() {//默认选中
      let table = this.$refs.chkTable;
      this.exportExcel.data.forEach(el => {
        this.list.forEach((ele) => {
          if (ele.id == el.id) {
            table.setCheckboxRow(table.getRowById(ele.id), true);
          }
        });
      })
      this.dataRefresh++;
    },
    selectChangeEvent({ rowIndex }) {
      this.$refs.chkTable.reloadRow(this.list, null, rowIndex)
      let leng = this.exportExcel.data.filter((el) => el.id == this.list[rowIndex].id)
       if (leng.length == 0 && this.list[rowIndex].checked) {
        this.exportExcel.data.push(this.list[rowIndex])
      }
      if(!this.list[rowIndex].checked && leng.length >0){
        this.exportExcel.data= this.exportExcel.data.filter(item=>item.id!==this.list[rowIndex].id)
      }
    },
    handleImport: function () {
      this.showImportModal = true;
    },
    getImportTemplate: function () {
      this.$axios.request({
        url: `//${this.domains.trans}/pole/config/GetPoleImportTemplate`,
        method: 'post',
        data: {},
        responseType: 'blob'
      }).then(res => {
        let url = window.URL.createObjectURL(res);
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `${this.showLang('com.import.temp.pole')}.xlsx`
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url)
      })
    },
    handleExport: function () {
      // let chks = this.$refs.chkTable.getCheckboxRecords();
      if (!this.exportExcel.isAll && this.exportExcel.data.length == 0) {
        this.$Message.warning(this.showLang('com.export.err.record'));
        return;
      }
      // let list = chks.map(p => p.id);
      let ajaxData = {
        "groupId": 0,
        "stationId": 0,
        "name": this.filter.name,
        "poleType": this.filter.poleType,
        "armType": this.filter.armType,
        "heightMin": this.filter.heightMin,
        "heightMax": this.filter.heightMax,
        "latMin": this.filter.latMin,
        "latMax": this.filter.latMax,
        "lngMin": this.filter.lngMin,
        "lngMax": this.filter.lngMax,
        "isAll": this.exportExcel.isAll,
        "ids": [],
        "url": 'http://' + this.domains.trans,
      }
      if (this.selectedNode.type == this.productCodes.station) {
        ajaxData.stationId = this.selectedNode.id;
      } else {
        ajaxData.groupId = this.selectedNode.id;
      }
      this.exportExcel.data.forEach(el => {
        ajaxData.ids.push(el.id)
      })
      this.$axios.request({
        url: `//${this.domains.trans}/station/config/ExportPoleQrCodeByFilter`,
        method: 'post',
        data: ajaxData,
        responseType: 'blob'
      }).then(res => {
        let url = window.URL.createObjectURL(res);
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `${this.showLang('com.export.fn.pole')}.xlsx`
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url)
      })
    },
    handleExport1: function () {
      if (!this.exportExcel.isAll && this.exportExcel.data.length == 0) {
        this.$Message.warning(this.showLang('com.export.err.record'));
        return;
      }
      this.filter.groupId = 0, this.filter.poleId = "";
      if (this.poleSelectedNode.isLeaf) {
        this.filter.poleId = this.poleSelectedNode.id;
      } else {
        this.filter.groupId = this.poleSelectedNode.id;
      }
      this.filter.ids = [];
      this.filter.url = `http://${this.domains.trans}`;
      this.filter.isAll = this.exportExcel.isAll;
      this.exportExcel.data.forEach(el => {
        this.filter.ids.push(el.id)
      })
      this.$axios.request({
        url: `//${this.domains.trans}/pole/config/ExportPoleByFilter`,
        method: 'post',
        data: this.filter,
        responseType: 'blob'
      }).then(res => {
        let url = window.URL.createObjectURL(res);
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `${this.showLang('com.export.fn.pole')}.xlsx`
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url)
      })
    },
    setTableHeight: function () {
      this.tabHeight = this.$refs.table1.clientHeight - 60;
    },
    fastAdd: function () {
      this.editItem = { isAdd: true, data: {} };
      this.showBatchModal = true;
    },
    handleAdd: function () {
      this.editItem = { isAdd: true, data: {} };
      this.showEditModal = true;
    },
    handleEdit: function (params) {
      this.editItem = { isAdd: false, data: params };
      this.showEditModal = true;
    },
    itemSaved: function () {
      this.getList();
    },
    deleteParams: function () {
      let chks = this.$refs.chkTable.getCheckboxRecords();
      if (chks.length == 0) {
        this.$Message.warning(this.showLang('com.tips.sel.del.record'));
        return;
      }
      let list = chks.map(p => p.id);
      this.$Modal.confirm({
        title: this.showLang('com.op.prompt'),
        content: this.showLang('com.tips.ok.del.record'),
        onOk: async () => {
          this.$axios.post(`//${this.domains.trans}/pole/config/DeletePoleInfo`, { list: list }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    setPicture(params) {
      this.editItem = { isAdd: false, data: params };
      this.showPicture = true;
    },
    handleDelete: function (params) {
      this.$Modal.confirm({
        title: this.showLang('com.op.prompt'),
        content: this.showLang('com.tips.ok.del.name', params.name),
        onOk: async () => {
          this.$axios.post(`//${this.domains.trans}/pole/config/DeletePoleInfo`, { list: [params.id] }).then(res => {
            if (res.code == 0) {
              this.getList();
            }
          });
        }
      });
    },
    getArmTypes: function(){
      this.$axios.post(`//${this.domains.trans}/pole/config/QueryArmType`, {}).then(res => {
        if (res.code == 0) {
          this.$set(this, 'armTypes', res.data);
        }
      });
    },
    getPoleTypes: function(){
      this.$axios.post(`//${this.domains.trans}/pole/config/QueryPoleType`, {}).then(res => {
        if (res.code == 0) {
          this.$set(this, 'poleTypes', res.data);
        }
      });
    },
    getList: function () {
      this.filter.groupId = 0, this.filter.poleId = "";
      if (this.poleSelectedNode.isLeaf) {
        this.filter.poleId = this.poleSelectedNode.id;
      } else {
        this.filter.groupId = this.poleSelectedNode.id;
      }
      this.$axios.post(`//${this.domains.trans}/pole/config/QueryPoleList`, this.filter).then(res => {
        if (res.code == 0) {
          this.$set(this, 'list', res.data.list);
          this.$set(this, 'total', res.data.count);
          setTimeout(() => {
            this.checkRowKeys();
          }, 100);
        }
      });
    },
  }
}
</script>
<style scoped>
.alarm-rule-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: stretch;
  /* padding: 10px; */
  /* padding-right: 40px; */
  /* border: solid 1px red; */
}
.query-data-area {
  height: 45px;
  flex: none;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.alarm-data-area {
  /* border: solid 1px red; */
  height: 100px;
  flex: auto;
  /* border: solid 1px #DCDEE2; */
  border-radius: 6px;
  padding-left: 10px;
}
.station-alarm-tabs {
  height: 30px;
  flex: none;
  display: flex;
}
.station-alarm-tab {
  padding: 3px 8px;
  margin: 3px 3px 0 3px;
  border: solid 1px lightgray;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  background-color: white;
}
.tab-active {
  border: solid 1px rgb(135, 159, 224);
  background-color: rgb(135, 159, 224);
  color: white;
}
.station-alarm-tabcontent {
  height: 500px;
  flex: auto;
  /* border: solid 1px red; */
}
/* .box-body{
  height: 0;
  flex: auto;
  margin-top: 5px;
  border: solid 1px red;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
}
.box-body::-webkit-scrollbar {
  display: none;
} */
</style>